var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "requisitions-table grid-x grid-padding-x grid-padding-y" },
    [
      _c("div", { staticClass: "cell medium-12 filter-by" }, [
        _vm._v("\n      Filter by\n  ")
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "cell auto" }, [
        _c(
          "div",
          { staticClass: "grid-x grid-padding-x select-filter-container" },
          [
            _c("div", { staticClass: "cell medium-2" }, [
              _c(
                "select",
                {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.requisitionStatus,
                      expression: "requisitionStatus"
                    }
                  ],
                  on: {
                    change: function($event) {
                      var $$selectedVal = Array.prototype.filter
                        .call($event.target.options, function(o) {
                          return o.selected
                        })
                        .map(function(o) {
                          var val = "_value" in o ? o._value : o.value
                          return val
                        })
                      _vm.requisitionStatus = $event.target.multiple
                        ? $$selectedVal
                        : $$selectedVal[0]
                    }
                  }
                },
                [
                  _c("option", { domProps: { value: null } }, [
                    _vm._v("Status")
                  ]),
                  _vm._v(" "),
                  _vm._l(_vm.requisitionStatuses, function(status) {
                    return _c("option", { domProps: { value: status.id } }, [
                      _vm._v(
                        "\n            " + _vm._s(status.title) + "\n          "
                      )
                    ])
                  })
                ],
                2
              )
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "cell medium-3" }, [
              _c(
                "select",
                {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.companyIdFilter,
                      expression: "companyIdFilter"
                    }
                  ],
                  on: {
                    change: function($event) {
                      var $$selectedVal = Array.prototype.filter
                        .call($event.target.options, function(o) {
                          return o.selected
                        })
                        .map(function(o) {
                          var val = "_value" in o ? o._value : o.value
                          return val
                        })
                      _vm.companyIdFilter = $event.target.multiple
                        ? $$selectedVal
                        : $$selectedVal[0]
                    }
                  }
                },
                [
                  _c("option", { domProps: { value: null } }, [
                    _vm._v("Business Unit")
                  ]),
                  _vm._v(" "),
                  _vm._l(_vm.companies, function(company) {
                    return _c("option", { domProps: { value: company.id } }, [
                      _vm._v(
                        "\n            " +
                          _vm._s(company.title) +
                          "\n          "
                      )
                    ])
                  })
                ],
                2
              )
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "cell medium-3" }, [
              _c(
                "select",
                {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.recruiterIdFilter,
                      expression: "recruiterIdFilter"
                    }
                  ],
                  on: {
                    change: function($event) {
                      var $$selectedVal = Array.prototype.filter
                        .call($event.target.options, function(o) {
                          return o.selected
                        })
                        .map(function(o) {
                          var val = "_value" in o ? o._value : o.value
                          return val
                        })
                      _vm.recruiterIdFilter = $event.target.multiple
                        ? $$selectedVal
                        : $$selectedVal[0]
                    }
                  }
                },
                [
                  _c("option", { domProps: { value: null } }, [
                    _vm._v("Recruiter")
                  ]),
                  _vm._v(" "),
                  _vm._l(_vm.users, function(user) {
                    return _c("option", { domProps: { value: user.id } }, [
                      _vm._v(
                        "\n            " +
                          _vm._s(user.full_name) +
                          "\n          "
                      )
                    ])
                  })
                ],
                2
              )
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "cell medium-2" }, [
              _c(
                "select",
                {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.atsTypeFilter,
                      expression: "atsTypeFilter"
                    }
                  ],
                  on: {
                    change: function($event) {
                      var $$selectedVal = Array.prototype.filter
                        .call($event.target.options, function(o) {
                          return o.selected
                        })
                        .map(function(o) {
                          var val = "_value" in o ? o._value : o.value
                          return val
                        })
                      _vm.atsTypeFilter = $event.target.multiple
                        ? $$selectedVal
                        : $$selectedVal[0]
                    }
                  }
                },
                [
                  _c("option", { domProps: { value: null } }, [
                    _vm._v("ATS Type")
                  ]),
                  _vm._v(" "),
                  _vm._l(_vm.atsTypes, function(atsType) {
                    return _c("option", { domProps: { value: atsType } }, [
                      _vm._v(
                        "\n            " +
                          _vm._s(
                            atsType
                              .replace(/_/g, " ")
                              .replace(/\w\S*/g, function(w) {
                                return w.replace(/^\w/, function(c) {
                                  return c.toUpperCase()
                                })
                              })
                          ) +
                          "\n          "
                      )
                    ])
                  })
                ],
                2
              )
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "cell medium-2" }, [
              _c(
                "select",
                {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.hasCostCenter,
                      expression: "hasCostCenter"
                    }
                  ],
                  on: {
                    change: function($event) {
                      var $$selectedVal = Array.prototype.filter
                        .call($event.target.options, function(o) {
                          return o.selected
                        })
                        .map(function(o) {
                          var val = "_value" in o ? o._value : o.value
                          return val
                        })
                      _vm.hasCostCenter = $event.target.multiple
                        ? $$selectedVal
                        : $$selectedVal[0]
                    }
                  }
                },
                [
                  _c("option", { domProps: { value: null } }, [
                    _vm._v("Cost Center")
                  ]),
                  _vm._v(" "),
                  _c("option", { domProps: { value: true } }, [
                    _vm._v("With Cost Center")
                  ]),
                  _vm._v(" "),
                  _c("option", { domProps: { value: false } }, [
                    _vm._v("Without Cost Center")
                  ])
                ]
              )
            ])
          ]
        )
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "cell shrink search-container" }, [
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.textFilter,
              expression: "textFilter"
            }
          ],
          staticClass: "mb-0 search-input",
          attrs: { type: "text", placeholder: "Search (Title)" },
          domProps: { value: _vm.textFilter },
          on: {
            input: function($event) {
              if ($event.target.composing) {
                return
              }
              _vm.textFilter = $event.target.value
            }
          }
        }),
        _vm._v(" "),
        _c("li", { staticClass: "fas fa-search search-icon" })
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "cell small-12" }, [
        _c("table", { staticClass: "mb-4" }, [
          _vm._m(0),
          _vm._v(" "),
          _c(
            "tbody",
            _vm._l(_vm.filteredRequisitions, function(req) {
              return _c("tr", { key: req.id }, [
                _c("td", [
                  _c(
                    "a",
                    {
                      attrs: {
                        href:
                          "/recruiter/active-requisitions/applicants/" + req.id
                      }
                    },
                    [
                      req.is_pipeline
                        ? _c("span", [_vm._v("[Pipeline]")])
                        : _vm._e(),
                      _vm._v(
                        " " +
                          _vm._s(req.person_specification.title) +
                          " (" +
                          _vm._s(req.id) +
                          ")"
                      )
                    ]
                  )
                ]),
                _vm._v(" "),
                _c("td", [
                  _vm._v(
                    _vm._s(req.person_specification.business_line.company.title)
                  )
                ]),
                _vm._v(" "),
                _c("td", [
                  _vm._v(_vm._s(req.cost_center ? req.cost_center.title : ""))
                ]),
                _vm._v(" "),
                _c("td", [
                  _vm._v(_vm._s(req.person_specification.business_line.title))
                ]),
                _vm._v(" "),
                _c("td", [
                  _vm._v(
                    _vm._s(
                      req.job_profile.external_requisition_number
                        ? req.job_profile.external_requisition_number
                        : ""
                    )
                  )
                ]),
                _vm._v(" "),
                _c("td", [_vm._v(_vm._s(req.status))]),
                _vm._v(" "),
                _c("td", [
                  _vm._v(
                    _vm._s(
                      req.job_profile.sage_job_requisition
                        ? req.job_profile.sage_job_requisition
                            .preferred_start_date
                        : ""
                    )
                  )
                ]),
                _vm._v(" "),
                _c("td", [
                  _vm._v(
                    _vm._s(
                      req.person_specification.ats_type.replace(
                        /(^|_)./g,
                        function(s) {
                          return " " + s.slice(-1).toUpperCase()
                        }
                      )
                    )
                  )
                ]),
                _vm._v(" "),
                _c("td", [
                  _c("div", { domProps: { innerHTML: _vm._s(req.area) } })
                ]),
                _vm._v(" "),
                _c(
                  "td",
                  { staticStyle: { "text-align": "center" } },
                  [
                    _c(
                      "a",
                      {
                        attrs: {
                          href:
                            "/recruiter/active-requisitions/applicants/" +
                            req.id
                        }
                      },
                      [_vm._v("Applications")]
                    ),
                    _vm._v(" "),
                    req.job
                      ? _c("span", { staticClass: "divider" }, [_vm._v("|")])
                      : _vm._e(),
                    _vm._v(" "),
                    req.job
                      ? _c(
                          "a",
                          {
                            attrs: {
                              href:
                                "/careers/vacancy/" +
                                req.job.id +
                                "/" +
                                req.job.title
                            }
                          },
                          [_vm._v("View")]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _c("span", { staticClass: "divider" }, [_vm._v("|")]),
                    _vm._v(" "),
                    _c(
                      "form",
                      {
                        staticStyle: { display: "inline-block" },
                        attrs: {
                          action:
                            "/recruiter/active-requisitions/clone/" + req.id,
                          method: "POST"
                        }
                      },
                      [
                        _c("input", {
                          attrs: { type: "hidden", name: "_csrfToken" },
                          domProps: { value: _vm.csrfToken }
                        }),
                        _vm._v(" "),
                        _c(
                          "a",
                          { attrs: { href: "#" }, on: { click: _vm.clone } },
                          [_vm._v("Clone")]
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _c("span", { staticClass: "divider" }, [_vm._v("|")]),
                    _vm._v(" "),
                    _c(
                      "a",
                      {
                        attrs: { id: "show-modal" },
                        on: {
                          click: function($event) {
                            ;(_vm.showModal = true), (_vm.reqId = req.id)
                          }
                        }
                      },
                      [_vm._v("Check-off")]
                    ),
                    _vm._v(" "),
                    _c(
                      "Teleport",
                      { attrs: { to: "body" } },
                      [
                        _c("modal", {
                          attrs: {
                            show: _vm.showModal,
                            requisitionId: _vm.reqId
                          },
                          on: {
                            close: function($event) {
                              _vm.showModal = false
                            }
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "header",
                                fn: function() {
                                  return [
                                    _c("h5", [_vm._v("Choose check-off phase")])
                                  ]
                                },
                                proxy: true
                              }
                            ],
                            null,
                            true
                          )
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c("span", { staticClass: "divider" }, [_vm._v("|")]),
                    _vm._v(" "),
                    _c(
                      "a",
                      {
                        attrs: {
                          href:
                            "/recruiter/active-requisitions/fail-bin/" + req.id
                        }
                      },
                      [_vm._v("Fail Bin")]
                    ),
                    _vm._v(" "),
                    req.is_pipeline && req.status !== "expired"
                      ? _c(
                          "a",
                          {
                            attrs: { href: "javascript:void()" },
                            on: {
                              click: function($event) {
                                _vm.toggleModal("convertModal")
                                _vm.jobPipeLineId = req.job.id
                              }
                            }
                          },
                          [
                            _c("span", { staticClass: "divider" }, [
                              _vm._v("|")
                            ]),
                            _vm._v(" Convert to Requisition")
                          ]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    req.is_pipeline && req.status === "expired"
                      ? _c(
                          "a",
                          {
                            staticClass: "divider",
                            attrs: { href: "javascript:void()" }
                          },
                          [
                            _c("span", { staticClass: "divider" }, [
                              _vm._v("|")
                            ]),
                            _vm._v(" Convert to Requisition")
                          ]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _c(
                      "a",
                      {
                        attrs: {
                          href: "/recruiter/active-requisitions/edit/" + req.id
                        }
                      },
                      [
                        _c("span", { staticClass: "divider" }, [_vm._v("|")]),
                        _vm._v(" Edit")
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "a",
                      {
                        attrs: { href: "/admin/indeed-campaigns/add/" + req.id }
                      },
                      [
                        _c("span", { staticClass: "divider" }, [_vm._v("|")]),
                        _vm._v(" Indeed\n            ")
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "a",
                      {
                        attrs: { href: "/admin/pnet/pnet-jobs/add/" + req.id }
                      },
                      [
                        _c("span", { staticClass: "divider" }, [_vm._v("|")]),
                        _vm._v(" Pnet\n            ")
                      ]
                    )
                  ],
                  1
                )
              ])
            }),
            0
          )
        ])
      ]),
      _vm._v(" "),
      _c("convert-to-requisition-modal", {
        ref: "convertModal",
        attrs: {
          "job-pipe-line-id": _vm.jobPipeLineId,
          "csrf-token": _vm.csrfToken
        }
      })
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("thead", [
      _c("tr", [
        _c("th", [_vm._v("Title")]),
        _vm._v(" "),
        _c("th", [_vm._v("Business Unit")]),
        _vm._v(" "),
        _c("th", [_vm._v("Cost Center")]),
        _vm._v(" "),
        _c("th", [_vm._v("Line Of Business")]),
        _vm._v(" "),
        _c("th", [_vm._v("External Requisition Number")]),
        _vm._v(" "),
        _c("th", { staticClass: "status" }, [_vm._v("Status")]),
        _vm._v(" "),
        _c("th", { staticClass: "status" }, [_vm._v("Preferred Start Date")]),
        _vm._v(" "),
        _c("th", [_vm._v("ATS Type")]),
        _vm._v(" "),
        _c("th", [_vm._v("Location")]),
        _vm._v(" "),
        _c("th", [_vm._v("Actions")])
      ])
    ])
  }
]
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-1a270d76", { render: render, staticRenderFns: staticRenderFns })
  }
}